import React from 'react';
import { TooltipContainer, Tooltip } from '@xo-union/tk-component-tooltips';

import styles from './BaseTooltip.scss';
import { IconButton } from '../../IconButton';
import classNames from 'classnames';

interface BaseTooltipProps {
  children?: React.ReactNode;
  shouldShowTooltip?: boolean;
  arrowOffsetFromCenterPercentage?: number;
  verticalOffset?: number;
  handleCloseTooltip: () => void;
  title: string;
  description: string;
  datatestid?: string;
  tooltipClassName?: string;
  arrowPosition?: 'top' | 'bottom';
}

const BaseTooltip = ({
  shouldShowTooltip = false,
  arrowOffsetFromCenterPercentage = 50,
  verticalOffset = 0,
  children,
  handleCloseTooltip,
  title,
  description,
  datatestid = 'BaseTooltip',
  tooltipClassName,
  arrowPosition = 'top',
}: BaseTooltipProps) => {
  const arrowUpStyle = { top: `calc(100% + ${verticalOffset}px)` };
  const arrowDownStyle = { bottom: `calc(100% + ${verticalOffset}px)` };

  return (
    <TooltipContainer className={styles.BaseTooltip__Container}>
      {children}
      {shouldShowTooltip && (
        <Tooltip
          data-testid={datatestid}
          className={classNames(styles.BaseTooltip, tooltipClassName)}
          style={arrowPosition === 'top' ? arrowUpStyle : arrowDownStyle}
          arrowOffset={arrowOffsetFromCenterPercentage}
          arrowPosition={arrowPosition}
        >
          <div className={styles.BaseTooltip__Content__Wrapper}>
            <div className={styles.BaseTooltip__Content__Container}>
              <div className={styles.BaseTooltip__Content__Title}>{title}</div>
              <div>{description}</div>
            </div>
            <IconButton
              className={styles.BaseTooltip__Content__CloseButton}
              name="close"
              size="sm"
              onClick={handleCloseTooltip}
              arialabel="close"
              datatestid={`${datatestid}__CloseButton`}
            />
          </div>
        </Tooltip>
      )}
    </TooltipContainer>
  );
};

export default BaseTooltip;
